import { OrderLocation, ParentOrder } from '@/types/order';
import storage from '@/utils/storage';

export const updateUser = (userData: any) => {
  const locationMap = storage.getItem('locationMap');

  const localCurrentLocation = sessionStorage.getItem('currentLocation');
  let currentLocation = storage.getItem('currentLocation');
  let sessionCurrentLocation = localCurrentLocation && JSON.parse(localCurrentLocation);
  currentLocation = locationMap[currentLocation.id];
  const pwaQRLocationId = storage.getItem('pwaQRLocationId');

  const initialLoad = sessionStorage.getItem('INITIAL_LOAD');
  const defaultLocationId = userData?.default_location_id;
  const config = storage.getItem('config');
  const currentUser = userData;
  currentUser.shortName = updateName(currentUser);
  storage.setItem('currentUser', currentUser);
  let reset = false;
  if (locationMap[defaultLocationId] && !initialLoad && !config?.otp_login && !pwaQRLocationId) {
    if (currentLocation?.id !== locationMap[defaultLocationId]?.id) {
      reset = true;
      currentLocation = locationMap[defaultLocationId];
    }
    if (!currentLocation) {
      currentLocation = locationMap[defaultLocationId] ?? locationMap[Object.keys(locationMap)[0]];
    }
    if (sessionCurrentLocation?.id !== locationMap[defaultLocationId].id) {
      sessionCurrentLocation = locationMap[defaultLocationId];
    }
    storage.setItem('currentLocation', currentLocation);
    sessionStorage.setItem('currentLocation', JSON.stringify(sessionCurrentLocation));
    sessionStorage.setItem('INITIAL_LOAD', '1');
  }

  if (pwaQRLocationId) {
    currentLocation = locationMap[pwaQRLocationId] ?? locationMap[Object.keys(locationMap)[0]];
    sessionCurrentLocation = currentLocation;
    storage.removeItem('pwaQRLocationId');
  }
  storage.setItem('currentLocation', currentLocation);

  if (!currentLocation) {
    currentLocation = locationMap[Object.keys(locationMap)[0]];
  }

  if (!sessionCurrentLocation) {
    sessionCurrentLocation = currentLocation;
  }

  sessionStorage.setItem('currentLocation', JSON.stringify(sessionCurrentLocation));

  return reset;
};

export const updateName = (currentUser: any) => {
  const { name } = currentUser;
  let username;
  if (name.length > 10) {
    if (name.indexOf(' ') > 3) {
      username = name.slice(0, name.indexOf(' '));
    } else if (name.lastIndexOf(' ') > 0) {
      username = name.slice(0, name.lastIndexOf(' '));
    } else {
      username = name;
    }
  } else {
    username = name;
  }
  return username;
};

export const isSocialDistancingActive = (location?: OrderLocation) => {
  const config = storage.getItem('config');

  if (!config?.social_distancing) {
    return false;
  }
  const currentLocation = storage.getItem('currentLocation');
  const enforcedCapacity = location?.enforce_capacity ?? currentLocation?.enforce_capacity ?? 0;

  if (enforcedCapacity >= 1) {
    return true;
  }
  return false;
};

export const hideQrCode = (order: ParentOrder) => {
  const config = storage.getItem('config');
  let hide = config?.hide_qrcode;
  if (isSocialDistancingActive(order.location.data)) {
    hide = false;
  }
  return hide;
};

export const getOtpLength = (data: any) => {
  const regex = data?.otp_regex.split(/[{}]/)[1];
  if (regex?.includes(',')) {
    const regexArr = regex
      .split(/[, ]/)
      .map((reg: string) => parseInt(reg, 10))
      .filter((item: number) => !Number.isNaN(item));
    return Math.max(...regexArr);
  }
  if (regex) {
    return parseInt(regex, 10);
  }
  return 4;
};

export const isSendSmsVisible = () => {
  const config = storage.getItem('config');
  return !config?.disable_sms_notifications;
};

export const isUserSettingVisible = () => {
  const config = storage.getItem('config');
  return config?.show_user_settings;
};
